/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Ip_TitleInputs */

const es_tyc_ip_title = /** @type {(inputs: Tyc_Ip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Propiedad Intelectual`)
};

const en_tyc_ip_title = /** @type {(inputs: Tyc_Ip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Intellectual Property`)
};

/**
* | output |
* | --- |
* | "5. Intellectual Property" |
*
* @param {Tyc_Ip_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_ip_title = /** @type {((inputs?: Tyc_Ip_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Ip_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_ip_title(inputs)
	return en_tyc_ip_title(inputs)
});
export { tyc_ip_title as "tyc.ip.title" }